import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Paper,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {ExpandMore, InfoOutlined} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {useForm} from '@dishtech-react/hooks';
import {useFolder} from '../../hooks/use-folder';
import {serviceConfig} from '../../../config/service-config';
import ManageAssetsFromEntry from '../helpers/manage-assets-from-entry';

const useStyles = makeStyles(() => ({
  dataPackageFRomEntryListItem: {
    color: '#212121',
    padding: '5px 7px',
    fontWize: '13px',
    wordWrap: 'break-word',
    whiteSpace: 'wrap',
    textOverflow: 'wrap',
    backgroundColor: '#f4f4f4',
  },
  tableHead: {
    color: '#212121',
    padding: '5px 7px',
    fontWize: '13px',
    wordWrap: 'break-word',
    whiteSpace: 'wrap',
    textOverflow: 'wrap',
    backgroundColor: '#e6e6e6',
    position: 'sticky',
    top: 0,
    zIndex: 10000,
  },
  ruidEntryInput: {display: 'block', width: '100%', resize: 'vertical'},
  formControlContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    justifyContent: 'right',
    gap: '10px',
  },
  foundAssetsTable: {
    marginBottom: '15px',
  },
  loading: {display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginTop: 20},
  accordionSummaryStyles: {display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'},

  foundAssetsTableWrapper: {maxHeight: '500px', overflowX: 'scroll', marginBottom: '15px'},
}));

const AddRuidsByEntryForm = () => {
  const classes = useStyles();

  const FORM_KEY = 'FOLDER';
  const {
    setDataPackagesFromEntry,
    addSelectedDataPackagesFromEntry,
    clearDataPackagesFromEntry,
    dataPackagesFromEntry,
    mode,
  } = useFolder();

  const {
    formValues: {dataPackages},
  } = useForm(serviceConfig, FORM_KEY, mode);

  const {ruidsFromEntry = [], dataPackagesFromEntryMap = new Map()} = dataPackagesFromEntry;
  const [selectedTableRows, setSelectedTableRows] = useState([]);
  const [currentlyAddedDataPackagesSet, setCurrentlyAddedDataPackagesSet] = useState(new Set());

  const tooltipTitleText =
    'Allows users to paste a collection of RUIDs as long as they are separated by a space, a comma or a line break. Works well when copy/pasting RUIDs from spreadsheets.';

  useEffect(() => {
    setCurrentlyAddedDataPackagesSet(new Set(dataPackages?.map(dp => dp.dataPackageId) || []));
  }, [dataPackages]);

  useEffect(() => {
    setSelectedTableRows(Array(ruidsFromEntry.length));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataPackagesFromEntry]);

  const handleSubmitRUIDEntryForm = ruidEntryString => setDataPackagesFromEntry(ruidEntryString);

  const handleClearEntry = () => clearDataPackagesFromEntry();

  const handleAddAllValid = () => addSelectedDataPackagesFromEntry(ruidsFromEntry);

  const handleAddSelectedRuids = () =>
    addSelectedDataPackagesFromEntry(ruidsFromEntry.filter((_, index) => selectedTableRows[index]));

  return (
    <Paper>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <div className={classes.accordionSummaryStyles}>
            <Typography variant="h6">Add RUIDs from text entry</Typography>
            <Tooltip placement="left" title={tooltipTitleText}>
              <InfoOutlined />
            </Tooltip>
          </div>
        </AccordionSummary>
        <AccordionDetails style={{display: 'block'}}>
          <ManageAssetsFromEntry
            dataPackageCollectionSetToCompareAgainst={currentlyAddedDataPackagesSet}
            dataPackagesFromEntryMap={dataPackagesFromEntryMap}
            ruidsFromEntry={ruidsFromEntry}
            selectedTableRows={selectedTableRows}
            setSelectedTableRows={setSelectedTableRows}
            onComponentUnmount={clearDataPackagesFromEntry}
            onRUIDEntryFormSubmit={handleSubmitRUIDEntryForm}
          />
          <div className={classes.formControlContainer}>
            <Button variant="contained" onClick={handleClearEntry}>
              Clear
            </Button>
            <Button color="primary" variant="contained" onClick={handleAddSelectedRuids}>
              Add Selection
            </Button>
            <Button color="primary" variant="contained" onClick={handleAddAllValid}>
              Add all valid
            </Button>
          </div>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default AddRuidsByEntryForm;
